import { render, staticRenderFns } from "./addFlightRuleModal.vue?vue&type=template&id=bb0e2f0c&scoped=true&"
import script from "./addFlightRuleModal.vue?vue&type=script&lang=ts&"
export * from "./addFlightRuleModal.vue?vue&type=script&lang=ts&"
import style0 from "./addFlightRuleModal.vue?vue&type=style&index=0&id=bb0e2f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0e2f0c",
  null
  
)

export default component.exports